import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
const sections = [{
  id: 'hero',
  label: 'Inicio'
}, {
  id: 'problem',
  label: 'El Problema'
}, {
  id: 'method',
  label: 'El Método'
}, {
  id: 'offer',
  label: 'Qué Incluye'
}, {
  id: 'audience',
  label: 'Para Quién'
}, {
  id: 'steps',
  label: 'Pasos'
}, {
  id: 'transformation',
  label: 'Transformación'
}, {
  id: 'pricing',
  label: 'Precio'
}, {
  id: 'guarantee',
  label: 'Garantía'
}, {
  id: 'final-cta',
  label: 'Comprar'
}];
export function ScrollProgress() {
  const [activeSection, setActiveSection] = useState('hero');
  useEffect(() => {
    const observers = sections.map(({
      id
    }) => {
      const element = document.getElementById(id);
      if (!element) return null;
      const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          setActiveSection(id);
        }
      }, {
        rootMargin: '-40% 0px -40% 0px'
      });
      observer.observe(element);
      return {
        element,
        observer
      };
    });
    return () => {
      observers.forEach(obs => {
        if (obs) obs.observer.unobserve(obs.element);
      });
    };
  }, []);
  return <div className="fixed right-6 top-1/2 -translate-y-1/2 z-50 hidden lg:flex flex-col gap-4" data-id="element-286">
      {sections.map(({
      id,
      label
    }) => <a key={id} href={`#${id}`} className="group relative flex items-center justify-end" aria-label={`Ir a ${label}`} data-id="element-287">
          <span className="absolute right-6 opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-xs font-medium text-charcoal-light whitespace-nowrap bg-cream-light/80 backdrop-blur-sm px-2 py-1 rounded" data-id="element-288">
            {label}
          </span>
          <motion.div className={`w-2.5 h-2.5 rounded-full transition-colors duration-500 ${activeSection === id ? 'bg-gold scale-125' : 'bg-cream-dark hover:bg-rose'}`} layout data-id="element-289" />
        </a>)}
    </div>;
}